//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import QuestionItem from '../_answer_components/question_item'
import AnsweredItem from '../_answer_components/answered_item'
export default {
    components: {
        QuestionItem,
        AnsweredItem,
    },
    props: {
        query_title: String,
        query_desc: String,
        current_question: Object,
        answered_questions: Array,
    },
    computed: {
        question () {
            return {
                ...this.current_question,
                order: this.answered_questions.length + 1
            }
        }
    }
}
